'use client';

import { useEffect, useState, useCallback, useRef } from 'react';
import { Dialog, DialogBackdrop, DialogPanel, TransitionChild } from '@headlessui/react';
import {
  Bars3Icon,
  CalendarIcon,
  DocumentDuplicateIcon,
  HomeIcon,
  UsersIcon,
  XMarkIcon,
  UserIcon,
  CalendarDaysIcon,
  BellIcon,
  PaperAirplaneIcon,
  Cog6ToothIcon,
  WalletIcon,
  ChartBarIcon,
  DocumentArrowUpIcon,
  PowerIcon,
    FolderIcon,
    ChatBubbleBottomCenterIcon,
    AcademicCapIcon,
    UserGroupIcon,
    ScaleIcon,
    Cog8ToothIcon



} from '@heroicons/react/20/solid';
import { Link, useNavigate } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import WeatherData from './weatherdata';

import { useContext } from 'react';
import { AuthContext } from '../AuthContext';
import { ChatBubbleBottomCenterTextIcon } from '@heroicons/react/24/solid';
import ManagerNav from './managernav';
import { CheckBadgeIcon } from '@heroicons/react/20/solid';
import CourseViewer from './courseviewer';
import { useLocation } from 'react-router-dom';
import StaffNav from '../staff/staffnav';
import { useWebSocket } from '../WebSocketContext';
import { getProfilePicSrc } from '../utils/mediaUrl';

export default function ChatDashboard() {
    const [clockedInStaff, setClockedInStaff] = useState([]);
    const [conversation, setConversation] = useState([]);
    const [comment, setComment] = useState('');
    const [person, setPerson] = useState(null);
    const [launchCourse, setLaunchCourse] = useState(null);
    const [isConversationActive, setIsConversationActive] = useState(false);
    const [showTask, setShowTask] = useState(null);
    const [task, setTask] = useState([]);
    const [staffWithNewMessages, setStaffWithNewMessages] = useState([]);
    const [messageSound] = useState(new Audio('/sound.mp3'));
    const [awaitingConnections, setAwaitingConnections] = useState({});
    const [connectionErrors, setConnectionErrors] = useState({});
    const [isRecording, setIsRecording] = useState(false);
    const [recordingSupported, setRecordingSupported] = useState(true);
    const [speechStatus, setSpeechStatus] = useState('idle');
    const [speechError, setSpeechError] = useState('');
    const recognitionRef = useRef(null);
    const isRecordingRef = useRef(false);
    const commentRef = useRef('');
    const speechBaseRef = useRef('');
    const speechTranscriptRef = useRef('');

useEffect(() => {
  if (!('webkitSpeechRecognition' in window) && !('SpeechRecognition' in window)) {
    setRecordingSupported(false);
    return;
  }

  if (!recognitionRef.current) {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const instance = new SpeechRecognition();
    
    instance.continuous = true;
    instance.interimResults = true;
    instance.lang = 'en-GB';
    instance.maxAlternatives = 1;

    instance.onstart = () => {
      isRecordingRef.current = true;
      setIsRecording(true);
      setSpeechStatus('listening');
      setSpeechError('');
    };

    instance.onresult = (event) => {
      let finalTranscript = '';
      let interimTranscript = '';

      for (let i = 0; i < event.results.length; i++) {
        const transcript = event.results[i][0].transcript;
        if (event.results[i].isFinal) {
          finalTranscript += `${transcript} `;
        } else {
          interimTranscript += transcript;
        }
      }

      const transcript = `${finalTranscript}${interimTranscript}`.trim();
      const combined = [speechBaseRef.current.trim(), transcript].filter(Boolean).join(' ');
      speechTranscriptRef.current = transcript;
      commentRef.current = combined;
      setComment(combined);
    };

    instance.onerror = (event) => {
      console.error('Speech error:', event.error);
      const errorMessages = {
        'not-allowed': 'Microphone access was blocked. Allow it in your browser site settings and try again.',
        'service-not-allowed': 'Speech recognition is blocked by this browser or device.',
        'audio-capture': 'No working microphone was detected.',
        'no-speech': 'No speech was detected. Try again and speak after Listening appears.',
        network: 'The browser speech service could not be reached.',
      };
      setSpeechError(errorMessages[event.error] || 'Speech recognition stopped unexpectedly.');
      setSpeechStatus('error');
      setIsRecording(false);
      isRecordingRef.current = false;
    };

    instance.onend = () => {
      isRecordingRef.current = false;
      setIsRecording(false);
      setSpeechStatus(currentStatus => currentStatus === 'error' ? 'error' : 'idle');
    };

    recognitionRef.current = instance;
  }

  return () => {
    const recognition = recognitionRef.current;
    if (recognition) {
      recognition.onstart = null;
      recognition.onresult = null;
      recognition.onerror = null;
      recognition.onend = null;
      recognition.abort();
      recognitionRef.current = null;
    }
    isRecordingRef.current = false;
  };
}, []);

const handleVoiceInput = useCallback(async () => {
  const recognition = recognitionRef.current;
  if (!recognition) {
    setSpeechError('Voice input is not supported in this browser. Use Chrome or Edge.');
    return;
  }

  if (isRecordingRef.current) {
    try {
      recognition.stop();
    } catch (e) {
      console.debug('Speech recognition was already stopped.', e);
    }
    isRecordingRef.current = false;
    setIsRecording(false);
    setSpeechStatus('idle');
    return;
  }

  try {
    setSpeechStatus('starting');
    setSpeechError('');

    if (navigator.mediaDevices?.getUserMedia) {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      stream.getTracks().forEach(track => track.stop());
    }

    speechBaseRef.current = commentRef.current;
    speechTranscriptRef.current = '';
    recognition.start();
  } catch (error) {
    console.error('Start error:', error);
    isRecordingRef.current = false;
    setIsRecording(false);
    setSpeechStatus('error');
    setSpeechError(error?.name === 'NotAllowedError'
      ? 'Microphone access was blocked. Allow it in your browser site settings and try again.'
      : 'Failed to start voice input. Check that your microphone is available.');
  }
}, []);

useEffect(() => {
  commentRef.current = comment;
}, [comment]);

    const clearConnectionError = (email) => {
      setConnectionErrors(prev => ({ ...prev, [email]: false }));
    };

    console.log(clockedInStaff);

    console.log(staffWithNewMessages);

    const user = useContext(AuthContext);
    const location = useLocation();



    console.log(person)
    console.log(user)

    const navigate = useNavigate();
    const { sendMessage } = useWebSocket();

    const fetchStaffAndClockin = useCallback(async () => {
      try {
        const [staffRes, clockinRes] = await Promise.all([
          fetch('https://api.insightos.co.uk/api/staff', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
          }),
          fetch('https://api.insightos.co.uk/api/clockins', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
          })
        ]);

        if (!staffRes.ok || !clockinRes.ok) {
          throw new Error('Failed to fetch staff or clockin data');
        }

        const staffData = await staffRes.json();
        const clockinData = await clockinRes.json();

        const staff = staffData.data || [];
        const clockins = clockinData.data || [];
       
        const merged = staff.map(member => ({
          ...member,
          clockin: clockins.find(c => c.StaffId === member.id) || null,
        }));

        console.log('Merged Staff and Clockin Data:', merged);

        setClockedInStaff(merged);
      } catch (error) {
        console.error('❌ Failed to fetch staff/clockins:', error);
      }
    }, []);

    useEffect(() => {
      const handleMessage = (event) => {
        const data = event.detail;

        if (data.type === "ping") return;

        if (data.success) {
          fetchStaffAndClockin();

          if (data.data) {
            messageSound.play().catch(e => console.error("Error playing sound:", e));

            if (data.data[0] && data.data[0].from) {
              setStaffWithNewMessages(prev => {
                if (!prev.includes(data.data[0].from)) {
                  return [...prev, data.data[0].from];
                }
                return prev;
              });
            }

            if (person && data.data[0] && (data.data[0].from === person.Email || data.data[0].to === person.Email)) {
              fetch('https://api.insightos.co.uk/api/conversation', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ to: person.Email }),
              })
                .then(response => response.json())
                .then(result => {
                  if (result.data) {
                    const sortedConversation = result.data.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
                    setConversation(sortedConversation);
                  }
                })
                .catch(error => console.error('❌ Failed to update conversation:', error));
            }
          }
        }
      };

      window.addEventListener('insightos-websocket-message', handleMessage);
      sendMessage({ type: 'ping' });
      fetchStaffAndClockin();

      return () => {
        window.removeEventListener('insightos-websocket-message', handleMessage);
      };
    }, [fetchStaffAndClockin, person, sendMessage]);

    // Runs on every new navigation to this route (location.key changes on every push/replace).
    // Handles both fresh mounts and same-route navigations from MessageAlert.
    useEffect(() => {
      if (location.state?.highlight) {
        const highlightEmail = location.state.highlight;
        setStaffWithNewMessages(prev =>
          prev.includes(highlightEmail) ? prev : [...prev, highlightEmail]
        );
        // Show sidebar so the flashing contact is visible on mobile
        setIsConversationActive(false);
        // Clear nav state immediately so staff poll re-renders never re-trigger this
        navigate(location.pathname, { replace: true, state: {} });
      }
    }, [location.key]); // eslint-disable-line

    useEffect(() => {
      // fetch conversation if it exists
      if (!person) return; // Exit early if no person is selected
      
      const fetchConversation = async () => {
        try {
          const response = await fetch('https://api.insightos.co.uk/api/conversation', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({
              to: person.Email,
            }),
          });
  
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
  
          const data = await response.json();
          console.log(data.data);
  
          // Only update conversation if there are actual messages from the server
          // This prevents overriding the initial "How can I help you today?" message
          if (data.data.length > 0) {
            const sortConversation = data.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setConversation(sortConversation);
          }
          // If no messages and conversation is empty, keep the existing state (don't override initial message)
        } catch (error) {
          console.error('Failed to fetch conversation:', error);
        }
      };

      // Initial fetch
      fetchConversation();

      // Setup polling interval
      const intervalId = setInterval(() => {
        fetchConversation();
      }, 10000);

      // Cleanup interval on unmount or when person changes
      return () => clearInterval(intervalId);
    }, [person, user.email]);

    const handleGoogleMeet = async (person) => {
      const email = person.Email;
      
      setAwaitingConnections(prev => ({ ...prev, [email]: true }));
      setConnectionErrors(prev => ({ ...prev, [email]: false }));
      
      try {
        const response = await fetch('https://api.insightos.co.uk/api/googlemeetchat', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({
            to: person.Email,
            clockinId: person.clockin?.id
          }),
        });

        const data = await response.json();
        
        if (!response.ok) {
          // Check if reauthorization is required
          if (data.requiresReauth) {
            console.log('Google reauthorization required');
            setAwaitingConnections(prev => ({ ...prev, [email]: false }));
            // Show a more persistent error for reauth
            setConnectionErrors(prev => ({ ...prev, [email]: 'reauth' }));
            // Don't auto-hide this error
            // if needs reauth send to /logout after 3 seconds
            setTimeout(() => {
              window.location.href = '/logout';
            }, 3000);

            return;
          }
          throw new Error(data.message || 'Failed to create Google Meet');
        }

        console.log('Google Meet created:', data);
        
        if (data.url) {
          setAwaitingConnections(prev => ({ ...prev, [email]: false }));
          window.open(data.url, '_blank');
        } else {
          throw new Error('No Meet URL received');
        }

      } catch (error) {
        console.error('Error creating Google Meet:', error);
        setAwaitingConnections(prev => ({ ...prev, [email]: false }));
        setConnectionErrors(prev => ({ ...prev, [email]: true }));
        
        // Auto-hide error after 3 seconds
        setTimeout(() => {
          setConnectionErrors(prev => ({ ...prev, [email]: false }));
        }, 3000);
      }
    };

    const handleClick = async (person) => {
      console.log(person);

      try {
      const response = await fetch('https://api.insightos.co.uk/api/conversation', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
        to: person.Email,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log(data.data);

      // Set person first to maintain conversation state
      setPerson(person);
      setIsConversationActive(true);

      // if there no conversation then create a object with empty array
      if (data.data.length === 0) {
        const initialMessage = {
          id: 0,
          from: user.email,
          to: person.Email,
          content: 'How can I help you today?',
          createdAt: new Date(),
          Accepted: 1,
          Course: "None"
        };
        
        // Set the conversation with the initial message immediately
        setConversation([initialMessage]);
        
        // Remove from flashing new messages list when clicked
        setStaffWithNewMessages(prev => prev.filter(email => email !== person.Email));
        
        return; // Exit early to prevent overriding with empty conversation
      }

      console.log(data.data);
      // sort the data.data array by createdAt so the latest message is at the top
      const sortConversation = data.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

      setConversation(sortConversation);
      
      // Remove from flashing new messages list when clicked
      setStaffWithNewMessages(prev => prev.filter(email => email !== person.Email));
     
      } catch (error) {
      console.error('Failed to fetch conversation:', error);
      }
    };

    const handleSubmit = async (e) => {
      e.preventDefault();

      if (person === null && conversation.length === 0) {
      console.log("No conversation or person selected");
      return;
      }

      try {
      // Determine the correct "to" field
      const recipientEmail = conversation[0].from !== user.email ? conversation[0].from : conversation[0].to;

      const response = await fetch('https://api.insightos.co.uk/api/addmessages', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
        to: recipientEmail,
        content: comment,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log(data);

      // Immediately add the new message to the conversation
      const newMessage = {
        id: data.id || Date.now(),
        from: user.email,
        to: recipientEmail,
        content: comment,
        createdAt: new Date().toISOString(),
        Accepted: 1
      };

      // Update conversation with the new message at the top
      setConversation(prev => [newMessage, ...prev]);

      // Fetch the updated conversation from server 
      const fetchResponse = await fetch('https://api.insightos.co.uk/api/conversation', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
        to: recipientEmail,
        }),
      });

      if (fetchResponse.ok) {
        const fetchData = await fetchResponse.json();
        const sortedConversation = fetchData.data.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setConversation(sortedConversation);
      }
      } catch (error) {
      console.error('Failed to send message:', error);
      }

      setComment(''); // Reset the comment input field
    };

    const handleAcceptClick = async (message) => {
      console.log(message);
      console.log(person);
      
      try {
      const response = await fetch('https://api.insightos.co.uk/api/accepttask', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        },
        credentials : 'include',
        body: JSON.stringify({
        id: message.id,
        person: message.clockinId
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log(data.data);
      handleClick(person);
      } catch (error) {
      console.error('Failed to accept task:', error);
      }
    }

    if (launchCourse) {
      return (
      <CourseViewer courseDocName={launchCourse} />
      )
    }

    console.log(conversation);

    const showAsRead = async (id) => {
      try {
      const response = await fetch(`https://api.insightos.co.uk/api/markread/${id}`, {
        method: 'PUT',
        headers: {
        'Content-Type': 'application/json',
        },
        credentials : 'include',
      });

      if (!response.ok) {
        throw new Error('Failed to mark message as read');
      }

      const data = await response.json();
      console.log(data);
      } catch (error) {
      console.error(error);
      }
    }

    

    return (
    <>
    {(user.access === 'admin' || user.access === 'manager') ? (
      <ManagerNav />   
    ) : (
      <StaffNav />
    )}

    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-sky-50 to-indigo-100 px-3 pb-8 pt-4 sm:px-6 lg:px-8">
    {/* Banner prompting calendar sync when permission not granted */}
    {!user.googleCalendarPermission && (
      <div className="mx-auto mt-2 w-full max-w-7xl rounded-2xl border border-yellow-200/70 bg-yellow-50/85 px-4 py-3 text-yellow-900 shadow-[0_10px_26px_rgba(180,138,0,0.18)] backdrop-blur-xl" role="alert">
        <div className="flex items-center justify-between gap-3">
          <p className="text-sm font-medium">Please sync your account to Google for video call permission. Visit Calendar to grant access.</p>
          <a href="/calendar" className="inline-flex items-center rounded-xl bg-gradient-to-br from-amber-500 to-orange-500 px-3 py-1.5 text-sm font-semibold text-white shadow-md transition hover:from-amber-400 hover:to-orange-400">Visit Calendar</a>
        </div>
      </div>
    )}

    {/* Main Content for Conversation */}
    <div className="mx-auto mt-4 grid min-h-[82vh] w-full max-w-7xl grid-cols-1 gap-4 md:grid-cols-3">
    {/* Sidebar */}
    <div
    className={`${
      isConversationActive ? 'hidden' : 'block'
    } sm:block md:col-span-1 overflow-y-auto rounded-3xl border border-white/35 bg-white/75 px-4 py-6 shadow-[0_16px_40px_rgba(15,23,42,0.16)] backdrop-blur-xl sm:px-6 lg:px-6`}
    >
    {/* Weather and Staff List */}
    <div className="mb-6 rounded-2xl border border-white/40 bg-gradient-to-r from-indigo-100/70 via-white/80 to-emerald-100/65 p-4 shadow-[0_10px_24px_rgba(15,23,42,0.12)] backdrop-blur-xl">
      <p className="text-xs font-semibold uppercase tracking-[0.14em] text-indigo-700">Team Chat</p>
      <h2 className="mt-1 text-lg font-semibold text-slate-900">Online Staff</h2>
    </div>
    <div>
      <ul role="list" className="space-y-3">
      {clockedInStaff.map((person) => (
      <button
      key={person.Email}
      onClick={() => {
        handleClick(person);
        setIsConversationActive(true); // Show conversation view on small screens
      }}
      data-component="chat-dashboard-staff"

      data-feature="open_conversation_post"
      className={`group flex w-full transform flex-col gap-y-3 rounded-2xl border px-1 py-3 text-left transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_16px_36px_rgba(15,23,42,0.2)] ${
        staffWithNewMessages.includes(person.Email)
          ? 'animate-pulse border-emerald-400/60 bg-gradient-to-br from-emerald-900/95 via-emerald-800/90 to-teal-700/90 shadow-[0_14px_35px_rgba(5,150,105,0.35)]'
          : 'border-indigo-300/40 bg-gradient-to-br from-indigo-950/95 via-indigo-900/90 to-blue-800/90 shadow-[0_12px_28px_rgba(30,58,138,0.35)]'
      }`}
      >
      <div className="flex items-center gap-x-4 px-4">
        <img
        alt=""
        src={getProfilePicSrc(person)}
        className="h-12 w-12 rounded-full border border-white/70 bg-gray-50 shadow-md"
        />
        <div className="flex flex-col">
        <p className="text-base font-semibold text-white">{person.Email === user.email ? 'Auto Messages' : person.Name}</p>
        <p className="text-sm text-indigo-100">{person.Role}</p>
        </div>
        <div className="ml-auto flex flex-col items-end gap-y-2 text-right text-sm text-indigo-100">
        {user.googleCalendarPermission ? (
          <div className="relative">
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleGoogleMeet(person);
              }}
              disabled={awaitingConnections[person.Email]}
              className="touch-manipulation rounded-full border border-white/60 bg-white/90 p-2 shadow-[0_10px_22px_rgba(15,23,42,0.18)] transition hover:scale-110 hover:shadow-[0_14px_28px_rgba(15,23,42,0.22)] disabled:cursor-not-allowed disabled:opacity-50"
              title="Start Google Meet"
            >
              {awaitingConnections[person.Email] ? (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
                </div>
              ) : (
                <img 
                  src="https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_1x_web_512dp.png" 
                  alt="Google Meet" 
                  className="h-6 w-6" 
                />
              )}
            </button>
            
            {/* Awaiting Connection Overlay */}
            {awaitingConnections[person.Email] && (
              <div className="absolute -top-12 left-1/2 z-10 -translate-x-1/2 whitespace-nowrap rounded-lg border border-white/20 bg-blue-600 px-2 py-1 text-xs text-white shadow-lg">
                Awaiting connection...
              </div>
            )}
            
            {/* Error Overlay */}
            {connectionErrors[person.Email] && (
              <div className="absolute -top-16 left-1/2 z-10 max-w-xs -translate-x-1/2 whitespace-nowrap rounded-lg border border-white/20 bg-red-600 px-2 py-1 text-xs text-white shadow-lg">
                {connectionErrors[person.Email] === 'reauth' ? (
                  <div className="text-center">
                    <p className="mb-1">Google auth expired</p>
                    <a 
                      href="/calendar" 
                      className="text-blue-200 underline hover:text-blue-100"
                      onClick={(e) => {
                        e.stopPropagation();
                        clearConnectionError(person.Email);
                      }}
                    >
                      Reconnect →
                    </a>
                  </div>
                ) : (
                  'Unable to connect'
                )}
              </div>
            )}
          </div>
        ) : null}
        {person.clockin?.Clockin === null ? (
        <p>Offline</p>
        ) : person.clockin?.ClockedIn === 1 ? (
        <div className="flex items-center gap-x-1 text-emerald-500">
        <div className="h-2 w-2 rounded-full bg-emerald-500 animate-pulse" />
        <p>Online</p>
        </div>
        ) : person.clockin?.Break === 1 ? (
        <p>Away</p>
        ) : (
        <div className="flex items-center gap-x-1 text-red-500">
        <div className="h-2 w-2 rounded-full bg-red-500" />
        <p>Offline</p>
        </div>
        )}
        </div>
      </div>
      </button>
      ))}
      </ul>
    </div>
    </div>

    {/* Main Content */}
    <div
    className={`${
      isConversationActive ? 'block' : 'hidden'
    } sm:block md:col-span-2 flex h-full min-h-0 flex-col rounded-3xl border border-white/35 bg-white/70 px-3 py-4 shadow-[0_16px_40px_rgba(15,23,42,0.16)] backdrop-blur-xl sm:px-5 sm:py-5 lg:px-6`}
    >
    {/* Back Button for Small Screens */}
    

      <div className="flex-1 overflow-y-auto px-2 py-3 pb-28 sm:px-4 sm:pb-32 lg:px-5">
      <button
      onClick={() => setIsConversationActive(false)}
      className="mb-5 w-full rounded-2xl border border-white/35 bg-gradient-to-r from-rose-500 to-red-500 p-2 text-white shadow-[0_10px_26px_rgba(239,68,68,0.25)] transition hover:from-rose-400 hover:to-red-400 focus:ring-2 focus:ring-red-300 focus:ring-offset-2 sm:hidden"
      >
      Back
      </button>
      {conversation.map((message) => (

      <div
      key={message.id}
      className={`flex ${
      message.from === user.email ? 'justify-end' : 'justify-start'
      } my-2`}
      >
      <div
      className={`max-w-xs md:max-w-sm px-4 py-3 rounded-xl shadow-lg text-white ${
        message.from === user.email
        ? 'rounded-tr-none border border-indigo-200/40 bg-gradient-to-br from-indigo-900/95 to-indigo-700/90 shadow-[0_14px_34px_rgba(49,46,129,0.35)]'
        : 'rounded-tl-none border border-emerald-200/40 bg-gradient-to-br from-emerald-700/95 to-emerald-500/90 shadow-[0_14px_34px_rgba(5,150,105,0.32)]'
      }`}
      >
      <p className="text-xs">{message.from === user.email ? '' : message.from}</p>
      <p className="text-sm">{message.content}</p>
      <p className="mt-1 text-xs text-gray-200">
        {new Date(message.createdAt).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        })}
      </p>
      <div className="flex items-center gap-x-2">
      {message.Accepted === 0  ? (
      <button 
      onClick={() => handleAcceptClick(message)}
      data-component="chat-dashboard-message"
      data-time-saved="2"
      data-feature="accept_task_post"
      className="mt-1 rounded-xl border border-white/25 bg-gradient-to-br from-indigo-600 to-indigo-500 px-2.5 py-1 text-xs font-semibold text-white shadow-[0_8px_18px_rgba(79,70,229,0.35)] transition hover:from-indigo-500 hover:to-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-300">

      Accept Task            </button>
      ) : (
      <div className="flex items-center">
        <div className="p-2 rounded-full bg-green-500 focus:ring-green-500 focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:outline-none"></div>
        <CheckBadgeIcon className="h-3 w-3 text-white" />
      </div>
      )}
      <div className="flex items-center gap-x-2">
      {message.training === 1  &&   (
      <button 
      onClick={() => setLaunchCourse(message.Course)}
      
      className="mt-1 rounded-xl border border-white/25 bg-gradient-to-br from-violet-600 to-fuchsia-600 px-2.5 py-1 text-xs font-semibold text-white shadow-[0_8px_18px_rgba(139,92,246,0.35)] transition hover:from-violet-500 hover:to-fuchsia-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-300">

      Launch Course            </button>
      )}
      {message.admintask === 1  &&   (
      <button 
      onClick={() => navigate('/admin-tasks')}
      
      className="mt-1 rounded-xl border border-white/25 bg-gradient-to-br from-violet-600 to-fuchsia-600 px-2.5 py-1 text-xs font-semibold text-white shadow-[0_8px_18px_rgba(139,92,246,0.35)] transition hover:from-violet-500 hover:to-fuchsia-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-300">

      Launch Task            </button>

      )}
      {message.admintask === 2  &&   (
      <button 
      onClick={() =>  navigate( "/viewappraisal", { state: { id: message.adminstaffid } })}
      
      className="mt-1 rounded-xl border border-white/25 bg-gradient-to-br from-violet-600 to-fuchsia-600 px-2.5 py-1 text-xs font-semibold text-white shadow-[0_8px_18px_rgba(139,92,246,0.35)] transition hover:from-violet-500 hover:to-fuchsia-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-300">

        To Appraisals           </button> 
      )}
      {message.help !== null && !showTask  && (
      <button 
      onClick={() => navigate('/team-tasks')}
      
      className="mt-1 rounded-xl border border-white/25 bg-gradient-to-br from-violet-600 to-fuchsia-600 px-2.5 py-1 text-xs font-semibold text-white shadow-[0_8px_18px_rgba(139,92,246,0.35)] transition hover:from-violet-500 hover:to-fuchsia-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-300">

       Show          </button> 
      )}
      {message.overtime === 1 && (
      <button 
      onClick={() => navigate('/overtime-manager') || showAsRead(message.id)}
      
      className="mt-1 rounded-xl border border-white/25 bg-gradient-to-br from-violet-600 to-fuchsia-600 px-2.5 py-1 text-xs font-semibold text-white shadow-[0_8px_18px_rgba(139,92,246,0.35)] transition hover:from-violet-500 hover:to-fuchsia-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-300">

       Overtime          </button> 
      )}
      {message.GoogleMeetUrl !== null && (
      <div className="mt-2">
        <img src="https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v6/web-512dp/logo_meet_2020q4_color_1x_web_512dp.png" alt="Google Meet" className="h-6 w-6 inline-block mr-2" />

        <a href={message.GoogleMeetUrl} target="_blank" rel="noopener noreferrer"
        className="text-xs text-white underline"
        >
          Join Google Meet
        </a>
      </div>
      )
      
        }
      
      </div>
      {message.replied === 0 && (
      <button onClick={() => showAsRead(message.id)}
      data-component="chat-dashboard-message"
      data-feature="mark_message_read_put"
      className="mt-1 rounded-xl border border-white/25 bg-gradient-to-br from-indigo-600 to-indigo-500 px-2.5 py-1 text-xs font-semibold text-white shadow-[0_8px_18px_rgba(79,70,229,0.35)] transition hover:from-indigo-500 hover:to-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-300">

      Mark As Read            </button>
      )}

      </div>


      
      </div>
      </div>
      ))}
      </div>

      {/* Fixed Form at Bottom */}
    {conversation.length > 0 && (
  <div className="sticky bottom-0 z-10 mt-2 w-full rounded-2xl border border-white/35 bg-white/90 px-4 py-3 shadow-[0_16px_36px_rgba(15,23,42,0.2)] backdrop-blur-xl sm:px-6 lg:px-8">
    <form onSubmit={handleSubmit} className="flex items-center gap-x-3">
      <div className="relative flex-1">
        <textarea
          value={comment}
          onChange={(e) => {
            commentRef.current = e.target.value;
            setComment(e.target.value);
          }}
          id="comment"
          name="comment"
          rows={3}
          placeholder={isRecording ? 'Listening...' : 'Type a message...'}
          className="block w-full resize-none rounded-xl border border-white/50 bg-white/70 px-3 py-2 text-base text-slate-900 placeholder:text-slate-400 shadow-inner focus:border-indigo-300 focus:outline-none focus:ring-2 focus:ring-indigo-200 sm:text-sm/6"
        />
        
        {/* Recording indicator */}
        {isRecording && (
          <div className="absolute bottom-2 right-2 flex items-center gap-2 bg-white/80 backdrop-blur-sm rounded-full px-3 py-1">
            <div className="flex items-center gap-1">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
              </span>
              <span className="text-xs text-gray-600 font-medium">Listening</span>
            </div>
          </div>
        )}
        {speechStatus === 'starting' && (
          <p className="mt-1 text-xs font-medium text-indigo-700">Requesting microphone...</p>
        )}
        {speechError && (
          <p className="mt-1 text-xs font-medium text-red-700" role="alert">{speechError}</p>
        )}
      </div>
      
      {/* Voice Input Button */}
      {recordingSupported && (
        <button
          type="button"
          onClick={handleVoiceInput}
          disabled={speechStatus === 'starting'}
          className={`flex-shrink-0 rounded-full border border-white/25 p-2.5 shadow-[0_12px_26px_rgba(16,185,129,0.32)] transition focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white ${
            isRecording 
              ? 'bg-gradient-to-br from-red-500 to-red-600 hover:from-red-400 hover:to-red-500 focus:ring-red-400 animate-pulse' 
              : 'bg-gradient-to-br from-purple-500 to-indigo-500 hover:from-purple-400 hover:to-indigo-400 focus:ring-purple-400 disabled:cursor-wait disabled:opacity-60'
          }`}
          title={speechStatus === 'starting' ? 'Requesting microphone' : isRecording ? 'Stop recording' : 'Voice input'}
        >
          {isRecording ? (
            <svg className="h-6 w-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <rect x="6" y="6" width="12" height="12" stroke="currentColor" strokeWidth="2" />
            </svg>
          ) : (
            <svg className="h-6 w-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
            </svg>
          )}
        </button>
      )}
      
      <button
        type="submit"
        data-component="message-sent"
        data-feature="message-sent"
        data-time-saved="2"
        className="flex-shrink-0 rounded-full border border-white/25 bg-gradient-to-br from-emerald-500 to-teal-500 p-2.5 shadow-[0_12px_26px_rgba(16,185,129,0.32)] transition hover:from-emerald-400 hover:to-teal-400 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:ring-offset-2 focus:ring-offset-white"
      >
        <PaperAirplaneIcon className="h-6 w-6 text-white" />
      </button>
    </form>
  </div>
)}

    </div>
    </div>
  </div>

    </>
    
    );
}
